import { http } from '../../config/axios'

 const postPropostaCreditoProcess = (proposta:any): Promise<any> => {
 
  return http
    .post('api/propostacredito/processproposta', proposta)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findServico', error)
      throw Error(error.response.data)
    })
}

export default postPropostaCreditoProcess;
